import { render } from "./VideoCarousel.vue?vue&type=template&id=08c755e0"
import script from "./VideoCarousel.vue?vue&type=script&lang=js"
export * from "./VideoCarousel.vue?vue&type=script&lang=js"

import "./VideoCarousel.vue?vue&type=style&index=0&id=08c755e0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__